export default "__VITE_ASSET__6d48a063__"